import { useLocation } from "@shared/react-router-dom/react-router-dom";

import {
  getSelfCheckoutFlowDescriptor,
  type SelfCheckoutFlow,
  type SelfCheckoutFlowDescriptor,
} from "./selfCheckoutFlow";
import { isDirectLabsSelfCheckoutPathname } from "./selfCheckoutFlowPaths";

/**
 * Resolves the active self-checkout flow descriptor.
 *
 * Path-derived by default — works on both surfaces because the labs path
 * shape is identical pre-auth (/checkout/:slug/labs/...) and post-auth
 * (/r/checkout/:slug/labs/...). Pass `explicitFlow` where the flow is known
 * from context rather than the URL (e.g. a page rendered outside the checkout
 * path shape).
 *
 * This hook is the ONLY place flow detection happens; everything downstream
 * reads the descriptor.
 */
const useSelfCheckoutFlow = (explicitFlow?: SelfCheckoutFlow): SelfCheckoutFlowDescriptor => {
  const { pathname } = useLocation();

  if (explicitFlow) return getSelfCheckoutFlowDescriptor(explicitFlow);

  return getSelfCheckoutFlowDescriptor(
    isDirectLabsSelfCheckoutPathname(pathname) ? "directLab" : "journey"
  );
};

export { useSelfCheckoutFlow };
